exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transaction-row {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-top: 1px solid #ccc;\n  -webkit-transition: border-color 0.3s ease;\n  transition: border-color 0.3s ease; }\n  .transaction-row .edit-icon {\n    display: none; }\n  .transaction-row:hover {\n    background-color: #61C6B4; }\n    .transaction-row:hover .edit-icon {\n      display: inline; }\n  .transaction-row.error {\n    background-color: #ff3333;\n    color: white; }\n", ""]);

// exports
